<div class="row">
  <div class="col-12 col-lg-6">
    <kpi-data [title]="'2.4 GHz'" [kpiItems]="kpiItems()" [kpiRows]="kpiRowsLeft()" />
  </div>
  <div class="col-12 col-lg-6">
    <kpi-data [title]="'5 GHz'" [kpiItems]="kpiItems()" [kpiRows]="kpiRowsRight()" />
  </div>
</div>
